export const SIDE_NAV_WIDTH = "300px";
export const MOBILE_NAV_HEIGHT = "72px";
export const SHOW_NEW_FEATURE_PANEL = true;
